import React, { useState } from 'react'
import { TreeViewDropdownLineProps } from './TreeViewDropdownLine.types'
import styles from './TreeViewDropdownLine.module.scss'
import cl from 'classnames'
import { Checkbox } from 'components/shared/Checkbox'
import { Text2 } from 'components/shared/Text2'
import { ExpandButton } from 'components/shared/ExpandButton'
import { Button } from 'components/shared/Button'
import { HorizontalLine } from 'components/shared/HorizontalLine'
import { ImageSquare } from 'components/shared/ImageSquare'

const TreeViewDropdownLineComponent = (props: TreeViewDropdownLineProps) => {
  const {
    className,
    style,
    label,
    secondaryLabelText,
    image,
    isSelected,
    isExpandable,
    onClick,
    children,
    treeLevel = 0
  } = props

  const childrenCount = (children || []).length
  const hasChildren = Boolean(children && childrenCount)
  const isGroupLabel = Boolean(hasChildren && !isExpandable)

  const [renderAllChildren, setRenderAllChildren] = useState(false)

  const renderChildren = () => {
    const isCollapsed = isExpandable && !renderAllChildren
    if (isCollapsed) return null

    const showMoreButton = !isExpandable && !renderAllChildren && childrenCount > 3
    const sliceEnd = renderAllChildren ? childrenCount : 3

    return (
      <>
        {children.slice(0, sliceEnd).map((line, index) => {
          return (
            <TreeViewDropdownLine
              key={index}
              {...line}
              treeLevel={treeLevel + 1}
            />
          )
        })}

        {showMoreButton && (
          <>
            <Button
              preset='link'
              onClick={() => setRenderAllChildren(true)}
              className={styles.showMoreButton}
            >
              {children.length - 3} more
            </Button>
            <HorizontalLine style={{ margin: 0 }} />
          </>
        )}
      </>
    )
  }

  const getSelectedChildrenCount = () => {
    return children.reduce((sum, child) => sum + (child.isSelected ? 1 : 0), 0)
  }

  return (
    <div
      className={cl(styles.container, className)}
      style={{
        marginLeft: treeLevel * 20,
        ...style
      }}
    >
      <div className={styles.dropdownLine}>
        <Checkbox
          className={styles.checkbox}
          isChecked={isSelected}
          onClick={onClick}
        />

        {isExpandable && (
          <ExpandButton
            className={styles.expandButton}
            onClick={() => setRenderAllChildren(s => !s)}
            isExpanded={renderAllChildren}
          />
        )}

        {image && <ImageSquare src={image} width={30} showBorder />}

        <Text2
          overflowEllipsis
          className={cl(styles.lineText, {
            [styles.groupLabel]: isGroupLabel
          })}
        >
          {label}
        </Text2>
        {secondaryLabelText && (
          <Text2 className={styles.LineTextSecondary}>
            {secondaryLabelText}
          </Text2>
        )}

        {isGroupLabel && (
          <Text2
            className={styles.LineTextSecondary}
            style={{ marginLeft: 'auto' }}
          >
            {getSelectedChildrenCount()}/{childrenCount}
          </Text2>
        )}
      </div>

      {hasChildren && renderChildren()}

    </div>
  )
}

const TreeViewDropdownLine = TreeViewDropdownLineComponent
export { TreeViewDropdownLine }
